import { unwrapResponse } from "../../response.js";
import { postJson, acceptJson } from "../../shared.js";
const getProductById = async (apiUrl, request) => {
  const expand = request.expand ? request.expand.join("|") : null;
  return unwrapResponse(
    await fetch(`${apiUrl}/${request.productId}?expand=${expand}`, {
      method: "GET",
      headers: {
        ...acceptJson,
        ...postJson
      }
    })
  );
};
const getProductBySlug = async (apiUrl, request) => {
  const expands = request.expand || [
    "attributes",
    "tax-category",
    "discounts",
    "categories",
    "product-type",
    "review-enabled"
  ];
  return unwrapResponse(
    await fetch(`${apiUrl}/slug/${request.slug}?expand=${expands.join("|")}`, {
      method: "GET",
      headers: {
        ...acceptJson,
        ...postJson
      }
    })
  );
};
export {
  getProductById,
  getProductBySlug
};
//# sourceMappingURL=product.js.map
